import { render, staticRenderFns } from "./PatientInfoCard.vue?vue&type=template&id=21ba7b80&"
import script from "./PatientInfoCard.vue?vue&type=script&lang=ts&"
export * from "./PatientInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports